import React from 'react';

const CertificateSeal = () => {
  // Generate points for a beautiful 40-point scallop (guaranteed to render perfectly)
  const points = [];
  const cx = 60, cy = 60, rOuter = 58, rInner = 52;
  for (let i = 0; i < 80; i++) {
    const angle = (i * 4.5 * Math.PI) / 180;
    const r = i % 2 === 0 ? rOuter : rInner;
    points.push(`${cx + r * Math.cos(angle)},${cy + r * Math.sin(angle)}`);
  }

  return (
    <div className="relative flex flex-col items-center justify-center">
      {/* Hanging Ribbons */}
      <svg width="140" height="90" viewBox="0 0 140 90" className="absolute -bottom-12 z-0">
        <polygon points="30,0 60,0 45,70 30,55 15,70" fill="#1A2340" />
        <polygon points="80,0 110,0 125,70 110,55 95,70" fill="#1A2340" />
      </svg>
      
      {/* Outer Scalloped Seal */}
      <svg width="120" height="120" viewBox="0 0 120 120" className="absolute z-10">
        <polygon points={points.join(' ')} fill="#6D4CFF" />
      </svg>
      
      {/* Inner Decorative Circles */}
      <div className="w-24 h-24 rounded-full bg-[#2D8CFF] border-2 border-[#ffffff] z-20 flex items-center justify-center relative">
        <div className="w-20 h-20 rounded-full border-[1px] border-dashed border-[#ffffff] flex items-center justify-center bg-[#1A2340] flex-col">
          <span className="text-white font-bold text-[8px] tracking-[0.2em] mb-1">OFFICIAL</span>
          <span className="text-[#6D4CFF] font-bold text-lg leading-none mb-1">CCAI</span>
          <span className="text-white font-medium text-[6px] tracking-[0.1em]">SEAL OF EXCELLENCE</span>
        </div>
        
        {/* Tiny stars */}
        <div className="absolute top-1 left-0 right-0 mx-auto flex justify-center text-white text-[6px]">★</div>
        <div className="absolute bottom-1 left-0 right-0 mx-auto flex justify-center text-white text-[6px]">★</div>
        <div className="absolute left-1 top-0 bottom-0 my-auto flex flex-col justify-center text-white text-[6px]">★</div>
        <div className="absolute right-1 top-0 bottom-0 my-auto flex flex-col justify-center text-white text-[6px]">★</div>
      </div>
    </div>
  );
};

export default CertificateSeal;
